export default "/images/845f199be07ddfd073ea12813d1d19ca.avif";